import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function checkProductEbookIsExist(params) {
	return client.get("user/cart/is_product_ebook_exist", {
		params: params,
	});
}


function refundSaldoCoinGenFromMidtrans(params) {
	return client.get("user/cart/refund_saldo_coin_gen_from_midtrans", {
		params: params,
	});
}
function getSaldoCoinGen(params) {
	return client.get("user/cart/saldo_coin_gen", {
		params: params,
	});
}

function getSaldoDepositReseller(params) {
	return client.get("user/cart/saldo_deposit_reseller", {
		params: params,
	});
}

function getCart(params) {
	return client.get("user/cart/data", {
		params: params,
	});
}

function getCartDetail(params) {
	return client.get("user/cart/detail", {
		params: params,
	});
}

function addItemCart(params) {
	return client.post("user/cart/add-item", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateItemCart(params) {
	return client.post("user/cart/update-item", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeProductCart(params) {
	return client.post("user/cart/remove-product", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkoutCart(params) {
	return client.post("user/cart/checkout", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function saveSnap(params) {
	return client.post("user/cart/save-snap", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getCart,
	getCartDetail,
	addItemCart,
	updateItemCart,
	removeProductCart,
	checkoutCart,
	saveSnap,
	getSaldoCoinGen,
	refundSaldoCoinGenFromMidtrans,
	getSaldoDepositReseller,
	checkProductEbookIsExist
};